import { SliderProduct2 } from "./skins/slider-product-2";
import { ProductSliderType } from "./slider-products.types";

const SliderProducts = ({
  product,
  styleClassName,
  disable,
}: ProductSliderType) => {
  return (
    <SliderProduct2
      className={styleClassName}
      imagesDetail={product?.imagesDetail}
      videoUrl={product?.videoLink as string}
      disable={disable}
    />
  );
};

export default SliderProducts;
